import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  //mode: 'history', //后端支持可开
  routes: [
    {
      path: '/', component: resolve => require(['@/components/common.vue'], resolve),redirect:'/Home',
      children: [{path: '/Home', component: resolve => require(['@/components/Home'], resolve)},
        {path: '/seek', component: resolve => require(['@/components/seek'], resolve)},

        {path: '/Product', component: resolve => require(['@/components/productCenter/Product'], resolve)},
        {
          path: '/Product/ProductInfo',
          component: resolve => require(['@/components/productCenter/ProductInfo'], resolve)
        },

        {path: '/ProjectCase', component: resolve => require(['@/components/projectCase/ProjectCase'], resolve)},
        {
          path: '/ProjectCase/ProjectCaseInfo',
          component: resolve => require(['@/components/projectCase/ProjectCaseInfo'], resolve)
        },

        {path: '/newsList', component: resolve => require(['@/components/news/newsList'], resolve)},
        {path: '/newsList/newsListInfo', component: resolve => require(['@/components/news/newsListInfo'], resolve)},

        {
          path: '/about', component: resolve => require(['@/components/about/about'], resolve),
          children: [
            {path: '/', component: resolve => require(['@/components/about/aboutInfo.vue'], resolve)},
            {path: '/intro', component: resolve => require(['@/components/about/intro.vue'], resolve)},
            {path: '/framework', component: resolve => require(['@/components/about/framework.vue'], resolve)},
            {path: '/course', component: resolve => require(['@/components/about/course.vue'], resolve)},
            {path: '/honor', component: resolve => require(['@/components/about/honor.vue'], resolve)},
            {path: '/culture', component: resolve => require(['@/components/about/culture.vue'], resolve)},
            {path: '/cultureInfo', component: resolve => require(['@/components/about/cultureInfo.vue'], resolve)},
            {path: '/notice', component: resolve => require(['@/components/about/notice.vue'], resolve)},
          ]
        },
        {path: '/domain', component: resolve => require(['@/components/domain/domain'], resolve)},
        {path: '/domain/terrace', component: resolve => require(['@/components/domain/terrace'], resolve)},
        {path: '/domain/shui', component: resolve => require(['@/components/domain/shui'], resolve)},

        {path: '/domain/illumination', component: resolve => require(['@/components/domain/illumination'], resolve)},
        {
          path: '/domain/airConditioner',
          component: resolve => require(['@/components/domain/airConditioner'], resolve)
        },
        {path: '/domain/EMC', component: resolve => require(['@/components/domain/EMC'], resolve)},
        {path: '/domain/photovoltaic', component: resolve => require(['@/components/domain/photovoltaic'], resolve)},
        {path: '/domain/refrigerant', component: resolve => require(['@/components/domain/refrigerant'], resolve)},
        {path: '/domain/heating', component: resolve => require(['@/components/domain/heating'], resolve)},
        {path: '/domain/hotWater', component: resolve => require(['@/components/domain/hotWater'], resolve)},

        {path: '/sustain', component: resolve => require(['@/components/sustain/sustain'], resolve)},
        {path: '/sustain/contact', component: resolve => require(['@/components/sustain/contact'], resolve)},
        {path: '/sustain/leaveWord', component: resolve => require(['@/components/sustain/leaveWord'], resolve)},
        {path: '/sustain/repairs', component: resolve => require(['@/components/sustain/repairs'], resolve)},
        {path: '/sustain/partner', component: resolve => require(['@/components/sustain/partner'], resolve)},
      ]
    },
    {path: '/noticeInfo', component: resolve => require(['@/components/about/noticeInfo.vue'], resolve)},

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js